import React from 'react';

import Header from '../components/Header'
import Footer from '../components/Footer'
import DocTech from '../components/DocTech'
import MainNavigation from '../components/MainNavigation'

export default (props) => (
    <div>
        <Header></Header>
        <MainNavigation></MainNavigation>
        <DocTech></DocTech>
        <Footer></Footer>
    </div>
)
